import type { Nullable } from "@core/domain/types/nullable.type";
import { BaseViewModel } from "@iot-platform/core";
import type { NotebookMessage } from "@notebook/domain/models/notebook-message.model";
import { injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class DetailMessageModalViewModel extends BaseViewModel {
    @observable
    notebookId: Nullable<string> = "";

    @observable
    notebookMessage: Nullable<Readonly<NotebookMessage>> = null;

    constructor() {
        super();
        makeObservable(this);
    }

    @action
    setNotebookMessage(notebookMessage: Readonly<NotebookMessage>): void {
        runInAction(() => {
            this.notebookMessage = notebookMessage;
        });
    }

    @action
    setNotebookId(notebookId: string): void {
        runInAction(() => {
            this.notebookId = notebookId;
        });
    }
}
